import { useQuery } from "react-query";
import { fetchPageTitleData } from "./api";

export function usePageTitle(filters, options = {}) {
  return useQuery(
    ["pageTitleData", filters],
    () => fetchPageTitleData(filters),
    {
      staleTime: 60000 * 600,
      cacheTime: 60000 * 6000,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
